import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Theme } from 'src/app/themes/models';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-palette-card',
  templateUrl: './palette-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class PaletteCardComponent {
  @Input() palette!: Theme;
}
